﻿(function () {

    // TODO: this needs to be gathered from data sent by the page (where I can determine what should be included)
    let smellyPieces = [];

    let $newPassword = $('.zxcvbn-password');
    let $scoreArea = $('.zxcvbn-score-area');
    let $suggestionArea = $('.zxcvbn-suggestions');

    $newPassword.on('input', function (e) {

        $scoreArea.removeClass(function (index, className) {

            // remove any css classes beginning with 'score-'
            return (className.match(/(^|\s)score-\S+/g) || []).join(' ');

        });

        let inputValue = (e.target.value || '').substring(0, 100);
        if ((inputValue === '') || (!zxcvbn))
            return;
        
        // calculate the password 'complexity' rating..
        let result = zxcvbn(inputValue, smellyPieces);
        $scoreArea.addClass('score-' + result.score);

        if ((result.feedback) &&
            ((result.feedback.warning) ||
                ((result.feedback.suggestions) && (result.feedback.suggestions.length > 0)))) {

            // include 'score-info' class if we have something to indicate..
            $scoreArea.addClass('score-info');

            let htmlContent = '';
            let hasSuggestions = ((result.feedback.suggestions) && (result.feedback.suggestions.length !== 0));

            if ((result.feedback.warning) && (result.feedback.warning.length !== 0)) {

                htmlContent += (hasSuggestions) ? '<p>' : '<p class="mb-0">';
                htmlContent += '<b>Why we think this password is weak</b>: ';
                htmlContent += result.feedback.warning;
                htmlContent += '</p>';

            }

            if (hasSuggestions) {

                let singleSuggestion = (result.feedback.suggestions.length === 1);

                htmlContent += (singleSuggestion) ? '<p class="mb-0">' : '<p>';
                htmlContent += '<b>Improve your password</b>:';

                if (singleSuggestion) {

                    htmlContent += ' ' + result.feedback.suggestions[0] + '</p>';

                } else {

                    htmlContent += '</p><ul class="mb-0">';
                    for (let i = 0; i < result.feedback.suggestions.length; i++)
                        htmlContent += '<li>' + result.feedback.suggestions[i] + '</li>';
                    htmlContent += '</ul>';

                }
            }

            $suggestionArea.html(htmlContent);

        }
    });

    $('a.info').popover({

        container: 'body',
        trigger: 'click hover',
        content: $suggestionArea[0],
        html: true

    });

}());
